import { useState } from "react";
import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";
import { useGenerateStockReplenishmentMutation } from "../../../store/apiSlice/warehouseApiSlice";
import { useNotification } from "../../../hooks/useNotification";
import { StockReplenishmentModal } from "./components/StockReplenishmentModal";

const ProductPlanAction = ({ selectedOrderId, setSelectedOrder }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [generateReplenishment, { isLoading }] = useGenerateStockReplenishmentMutation();
  const notify = useNotification();

  const closeModal = () => setIsOpenModal(false);

  const handleApply = async () => {
    try {
      const { created, skipped } = await generateReplenishment({
        trigger_type: "manual",
        product_plan_ids: selectedOrderId?.length === 0 ? "all" : selectedOrderId,
      }).unwrap();

      let message = "";
      let notificationType = "success";

      if (created === 0) {
        message =
          "No replenishments were created. All product plans were skipped due to various reasons.";
        notificationType = "error";
      } else if (skipped > 0) {
        message =
          "Replenishments were created for some product plans. Some were skipped due to various reasons.";
      } else {
        message = "Replenishments were successfully created for all selected product plans.";
      }

      notify({
        type: notificationType,
        message,
      });
      setSelectedOrder([]);
      closeModal();
    } catch (error) {
      const err = error?.data;
      notify({
        type: "error",
        message: err?.detail || "Something went wrong. Please try again.",
      });
    }
  };

  return (
    <>
      <li className={`tableButton activeState`}>
        <button onClick={() => setIsOpenModal(true)}>Stock Replenishment</button>
      </li>

      {isOpenModal && (
        <StockReplenishmentModal
          isLoading={isLoading}
          handleApply={handleApply}
          closeModal={closeModal}
          description={
            selectedOrderId?.length === 0
              ? "Stock replenishment will be triggered for all product plans. To generate for individual plans, select them manually."
              : "Stock replenishment will be triggered for selected product plans"
          }
        />
      )}
    </>
  );
};

export const ProductPlanActionWithCheck = componentWithCondition(ProductPlanAction);
